/* 検索項目 日付 */
import React, { memo, createRef } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { business_day_calendar as config, months } from '../Const';
import Moment from 'moment';

interface Props {
  id: string;
  name: string;
  label: string;
  value: Date | null;
  valid_message?: Array<string>;
  handleChange: (date: Date) => void;
}

const SearchDate: React.FC<Props> = ({ id, name, label, value, valid_message, handleChange }) => {
  const ref = createRef<HTMLInputElement>();

  // 開始日から終了日までの年のコレクションを作成する
  const years: number[] = [];
  const dateFrom = Moment(new Date()).add(config.min_date, 'd');
  const dateTo = Moment(new Date())
    .add(config.max_year, 'y')
    .subtract('1', 'd');

  for (let i = Number(dateFrom.format('YYYY')); i <= Number(dateTo.format('YYYY')); i++) {
    years.push(i);
  }

  // 配列を反転させる
  years.reverse();

  /**
   * カレンダーアイコン押下時の処理
   * @return void
   */
  const handleCalendar = (): void => {
    const obj = document.getElementById(id);
    if (obj !== null) {
      obj.click();
    }
  };

  return (
    <div className="col-md-4">
      <DatePicker
        id={id}
        name={name}
        onChange={handleChange}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div>
            <button
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
              className="navigation-previous"
            >
              {'<'}
            </button>
            <select
              value={date.getFullYear()}
              onChange={({ target: { value } }) => changeYear(Number(value))}
            >
              {years.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <span>年</span>
            <select
              value={months[date.getMonth()]}
              onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
            >
              {months.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <button
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
              className="navigation-next"
            >
              {'>'}
            </button>
          </div>
        )}
        customInput={
          <div>
            <span className="search-criteria-head">{label}</span>
            <div className="search-form-input-large search-date" ref={ref}>
              <div className="date-input" onClick={handleCalendar}>
                {value ? Moment(value).format('YYYY/MM/DD') : '年/月/日'}
              </div>
              <button className="calender">
                <FontAwesomeIcon
                  className="fa-calender"
                  icon={faCalendar}
                  onClick={handleCalendar}
                />
              </button>
              {valid_message && (
                <span className="is-invalid">
                  <strong>{valid_message[0]}</strong>
                </span>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default memo(SearchDate);
